import Page from "components/Page";
import { GetStaticProps } from "next";
import Image from "components/commons/Image";
import * as MessageIcon from "public/assets/img/icons/message.svg";
import Icon from "components/commons/Icon";
import { Link } from "components/commons/Link";
import ContactUsForm from "components/home/ContactUsForm";
import Layout from "components/layouts/Layout";
import { useTranslations } from "next-intl";
import { ReactElement } from "react";
import Facebook from "@/assets/img/icons/facebook.svg";
import Linkedin from "@/assets/img/icons/linkedin.svg";
import Youtube from "@/assets/img/icons/youtube.svg";
import AppLayout from "components/layouts/AppLayout";

function ContactUs() {
  const t = useTranslations("contatos");

  let mailTo = "mailto:" + t("detailEmail");
  let telTo = "tel:" + t("detailPhoneNumber");

  return (
    <Page
      id="contact-us"
      title={t("metadata-title")}
      description={t("metadata-description")}
      className="bg-white md:p-0"
      footer
    >
      <div className="mx-auto md:pt-32 pb-14 max-w-7xl">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h1 className="text-black text-7xl text-center md:text-left mb-6 font-bold md:text-10xl md:font-extrabold md:mt-4">
              {t("title")}
            </h1>
            <p className="text-black text-lg">{t("details-1")}</p>
            <p className="text-black text-lg">{t("details-2")}</p>
            <p className="text-black text-lg mt-2">{t("details-3")}</p>
            <div className="space-y-1 mt-4">
              <div className="text-black text-lg font-bold">
                {t("details-4")}
              </div>
              <div>
                <Link
                  href={mailTo}
                  className="font-semibold text-black"
                  text={t("detailEmail")}
                  prefetch={false}
                />
              </div>
              <div>
                <Link
                  href={telTo}
                  className="font-semibold text-black"
                  text={t("detailPhoneNumber")}
                  prefetch={false}
                />
              </div>
            </div>
            <div className="flex -ml-2 space-x-4 mt-4">
              <Link href="https://www.facebook.com/visorc/" target="_blank">
                <Icon src={Facebook} alt="facebook" />
              </Link>
              <Link
                href="https://www.linkedin.com/company/visualorc"
                target="_blank"
              >
                <Icon src={Linkedin} alt="linkedin" />
              </Link>
              <Link
                href="https://www.youtube.com/@visualorcsoftware"
                target="_blank"
              >
                <Icon src={Youtube} alt="youtube" />
              </Link>
            </div>
          </div>
          <div className="border-gray-600 border mt-4 md:m-8 rounded-lg shadow-2xl py-6 px-8">
            <Image
              src={MessageIcon}
              title={t("sendMessage")}
              height={72}
              width={72}
            ></Image>
            <ContactUsForm />
          </div>
        </div>
      </div>
    </Page>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
      context,
      messages: (await import(`../lang/${context.locale}.json`)).default,
    },
  };
};

ContactUs.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout variant="secondary">
      <AppLayout>{page}</AppLayout>
    </Layout>
  );
};

export default ContactUs;
